var BaseView = require('../../../customize/contents/pattern/patterns');

module.exports = BaseView.extend({
  callbackName: 'callbackAdminBackgrounds'
});
